import _ from 'lodash';
import React from 'react';
import parse from 'html-react-parser';
import { WppObjectDivider, WppGrid, WppTypography } from 'buildingBlocks';
import { BULLET_POINTS } from '../constants';
import { dataUploader } from '../style';
import FileUploaderSection from './FileUploaderSection';

const { list, bulletPoint, column, bulletGrid } = dataUploader;

const DataUploaderForm = () => (
  <WppGrid item container all={24} fullWidth>
    <WppGrid item all={12} style={bulletGrid}>
      <ul style={list}>
        {_.map(BULLET_POINTS, (bullet: string, idx: number) => (
          <li key={idx} style={bulletPoint}><WppTypography type="s-body" tag="span">{parse(bullet)}</WppTypography></li>
        ))}
      </ul>
      <WppObjectDivider vertical style={{ height: 'auto', marginRight: '21px' }} />
    </WppGrid>
    <WppGrid item all={12} style={column}>
      <FileUploaderSection />
    </WppGrid>
  </WppGrid>
);

export default DataUploaderForm;
